import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    SelectChangeEvent,
} from "@mui/material";
import { useState, useEffect } from "react";
import EnhancedAxios from "../../axios/EnhancedAxios";
import { AxiosResponse, AxiosError } from "axios";
import { useSelector } from "react-redux";
import { errorAlert } from "../../utils/alerts/alerts";

type Props = {
    value: string;
    onChange: (value: string) => void;
};

const GiftTypeFilterBox = ({ value, onChange }: Props) => {
    const userToken = useSelector((state: any) => state.user.userToken);
    const [options, setOptions] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        EnhancedAxios(null, userToken)
            .get(
                `/categories?filters=parent_id:${process.env.REACT_APP_GIFT_TYPE_CAT_ID}&paginate=9999`
            )
            .then((res: AxiosResponse) => {
                setOptions(res.data.data || []);
                setLoading(false);
            })
            .catch((error: AxiosError) => {
                errorAlert("حدث خطأ أثناء عرض التصنيفات برجاء إعادة تحميل الصفحة");
                setLoading(false);
            });
    }, [userToken]);

    const handleChange = (e: SelectChangeEvent<string>) => {
        onChange(e.target.value);
    };

    return (
        <Box
            sx={{
                flex: "1",
                minWidth: "230px",
            }}
        >
            <FormControl fullWidth>
                <InputLabel>النوع</InputLabel>
                <Select
                    name="gift_type_filter"
                    value={value}
                    label="النوع"
                    onChange={handleChange}
                >
                    <MenuItem value={"all"}>
                        الكل
                    </MenuItem>
                    {loading ? (
                        <MenuItem disabled value="">
                            تحميل...
                        </MenuItem>
                    ) : (
                        options.map((option: any) => (
                            <MenuItem key={option.id} value={option.id}>
                                {option.name}
                            </MenuItem>
                        ))

                    )}
                </Select>
            </FormControl>
        </Box>
    );
};

export default GiftTypeFilterBox;
